/**
 * Contem as configuracoes especificas para cada uma das impressoras suportadas:
 *
 * 1 - Bematech Mp-20
 * 2 - Epson Tm-T88IIP
 * 3 - Bematech Mp-2100
 * 4 - Bematech Mp-4000
 * 5 - Sewoo - Chile
 * 6 - IBM-4610 - Colombia
 * 7 - Bematech MP-100 - Peru
 * 8 - Daruma DR600
 * 9 - Epson TM-U22A
 * 10 - Daruma DR700
 * 11 - Epson M244A
 * 12 - Zebra Tlp 2844
 * 13 - Bematech MP-4200
 * 14 - Epson TM-T88V
 * 16 - Epson TM-T20
 * 17 - Sweda SI-300S
 * 18 - Elgin I9
 * 19 - Epson TM-T88IV Ethernet
 * 20 - Elgin Kiosk BKT681
 * 21 - Bematech MP-4200 - Compartilhada
 * 23 - Custom TG2480H
 * 25 - GPOS700
 * 26 - Poynt
 * 28 - TecToy K2 Mini (Android) - Impressora pequena
 * 29 - TecToy K2 Mini (Android) - Impressora grande
 * 55 - Menno mm300H
 * 57 - TC-35
 */
import Util from './util'
const printerParameters = {
    // Bematech Mp-20
    1: {
        largura: 36,
        larguraCupom: 36,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Epson Tm-T88IIP
    2: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Bematech Mp-2100
    3: {
        largura: 48 + 17,
        larguraCupom: 48 + 17,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Bematech Mp-4000
    4: {
        largura: 64,
        larguraCupom: 64,
        tipoLetra: 1,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Sewoo - Chile
    5: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // IBM-4610 - Colombia
    6: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Bematech MP-100 - Peru
    7: {
        largura: 40,
        larguraCupom: 40,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Daruma DR600
    8: {
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Epson TM-U22A
    9: {
        largura: 40,
        larguraCupom: 40,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Daruma DR700
    10: {
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Epson M244A
    11: {
        largura: 40,
        larguraCupom: 40,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Zebra Tlp 2844
    12: {
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Bematech MP-4200
    13: {
        /* para dll antiga deve colocar 47 pra nova deve colocar 41 */
        /* dll nova nao esta centralizando o qrcde */
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: String.fromCharCode(27, 33, 48),
        reset: String.fromCharCode(27, 64)
    },
    // Epson TM-T88V
    14: {
        largura: Util.isAndroidMode() ? 41 : 56,
        larguraCupom: Util.isAndroidMode() ? 41 : 56,
        tipoLetra: 1,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: String.fromCharCode(29, 66, 1),
        fontExpanded: String.fromCharCode(29, 33, 17),
        reset: String.fromCharCode(27, 64)
    },
    // Epson TM-T20
    16: {
        largura: Util.isAndroidMode() ? 48 : 64,
        larguraCupom: Util.isAndroidMode() ? 48 : 64,
        tipoLetra: 1,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: String.fromCharCode(29, 66, 1),
        fontExpanded: String.fromCharCode(29, 33, 17),
        reset: String.fromCharCode(27, 64)
    },
    // Sweda SI-300S
    17: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Elgin I9
    18: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Epson TM-T88IV Ethernet
    19: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: String.fromCharCode(29, 66, 1),
        fontExpanded: String.fromCharCode(29, 33, 17),
        reset: String.fromCharCode(27, 64)
    },
    // Elgin Kiosk BKT681
    20: {
        largura: 59,
        larguraCupom: 59,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: null,
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Bematech MP-4200 - Compartilhada
    21: {
        largura: 42,
        larguraCupom: 42,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Custom TG2480H
    23: {
        largura: 43,
        larguraCupom: 43,
        tipoLetra: 1,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(105),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // GPOS700 - Gertec
    25: {
        largura: 38,
        larguraCupom: 38,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // Poynt
    26: {
        largura: 32,
        larguraCupom: 32,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // CieloLio v2
    27: {
        largura: 37,
        larguraCupom: 37,
        tipoLetra: 1,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: null,
        impressaoFront: true,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // TecToy K2 Mini (Android) - Impressora pequena
    28: {
        largura: 32,
        larguraCupom: 32,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        androidPrinter: true,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // TecToy K2 Mini (Android) - Impressora grande
    29: {
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        androidPrinter: true,
        printerType: 29,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // menno
    55: {
        largura: 43,
        larguraCupom: 43,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        androidPrinter: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // impressora do totem chines no showroom
    57: {
        largura: 47,
        larguraCupom: 47,
        tipoLetra: 2,
        comandoEnter: String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(109),
        impressaoFront: false,
        printerType: 57,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    99: {
        largura: 48,
        larguraCupom: 48,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    // GERTEC sk210
    300: {
        largura: 34,
        larguraCupom: 34,
        tipoLetra: 1,
        comandoEnter: '\n',
        comandoCortePapel: null,
        impressaoFront: true,
        androidPrinter: true,
        inverted: '',
        fontExpanded: '',
        reset: ''
    },
    default: {
        largura: 49,
        larguraCupom: 49,
        tipoLetra: 3,
        comandoEnter: String.fromCharCode(13) + String.fromCharCode(10),
        comandoCortePapel: String.fromCharCode(27) + String.fromCharCode(119),
        impressaoFront: false,
        inverted: '',
        fontExpanded: '',
        reset: ''
    }
}

export default {
    getPrinterParameters: function (printerType) {
        let params = printerParameters[printerType]
        if (!params) {
            params = printerParameters['default']
        }
        return params
    }
}



// WEBPACK FOOTER //
// ./src/assets/libs/PrinterParameters.js